module.exports = __webpack_public_path__ + "img/user_nophoto.fcdbc6d8.svg";